import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["radio"]

  select(event) {
    if (!this.hasRadioTarget) return
    if (event.target.closest('[data-action*="accordion#toggle"]')) return

    const radio = this.radioTarget.querySelector('input[type="radio"]')
    
    radio.checked = true
  }
}